import { useRouter } from "next/router";
import { useIntl } from "react-intl";
import { NextSeo } from "next-seo";
import { useMemo } from "react";

import Section from "../../../components/Section";
import SectionLayout from "../../../components/[przyjaznedeklaracje]/_sectionLayout";
import Header from "../../../components/Header";
import Banner from "../../../components/Banner";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Footer from "../../../components/Footer";
import CookieAccept from "../../../components/CookieAccept";

import AuthorSection1PL from "../../../content/przyjaznedeklaracje/autorzy/krystyna-gasiorek/section-1_pl.mdx";
import AuthorSection2PL from "../../../content/przyjaznedeklaracje/autorzy/krystyna-gasiorek/section-2_pl.mdx";

export default function Autorzy(props) {
	const router = useRouter();
	const intl = useIntl();

	let hostName = "https://przyjazne-deklaracje.pl";
	let routerUrl = router.asPath;
	let routerLocale = router.locale;
	let Miasto = "PRZYJAZNEDEKLARACJE";
	let Podatek = "authors";
	let Authors = "krystynaGasiorek";
	let title = props.title;

	// Memoizowanie tłumaczeń dla SEO
	const seoTitle = useMemo(() => {
		return intl.formatMessage({
			id: `miasta.${Miasto}.SEO.${Podatek}.${Authors}.title`,
		});
	}, [intl, Miasto, Podatek, Authors]);

	const seoDescription = useMemo(() => {
		return intl.formatMessage({
			id: `miasta.${Miasto}.SEO.${Podatek}.${Authors}.description`,
		});
	}, [intl, Miasto, Podatek, Authors]);

	return (
		<>
			{/* HEAD */}
			<NextSeo
				title={seoTitle}
				description={seoDescription}
				canonical={`${hostName}${routerUrl}`}
				// openGraph={{
				//   site_name: intl.formatMessage({
				//     id: `miasta.${Miasto}.siteName`,
				//   }),
				//   type: "website",
				//   locale: routerLocale,
				//   url: witryna ? hostName + RouterRedirect : hostName + routerUrl,
				//   title: seoTitle,
				//   description: seoDescription,
				//   images: [
				//     {
				//       url: heroImg.mobile,
				//     },
				//   ],
				// }}
			/>

			{/* TOP */}
			<Header miasto={Miasto} />

			<Banner
				miasto={Miasto}
				podatek={Podatek}
				author={Authors}
				small
				title={title}
				description={props.description}
			/>

			<Breadcrumbs miasto={Miasto} layout="light" title={title} />

			{/* SECTION */}
			<Section mdx lightdark>
				<AuthorSection1PL />
			</Section>

			<Section mdx>
				<AuthorSection2PL />
			</Section>

			{/* BOTTOM */}
			<Footer miasto={Miasto} />
		</>
	);
}
